import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomModal } from '../../../shared/services/ziro-modal.service';

interface PreviewModalViewProperties {
  image: string;
  type: 'LOGO' | 'BACKGROUND_IMAGE';
}

@Component({
  selector: 'ziro-admin-customize-ui-preview-modal',
  templateUrl: './customize-ui-preview-modal.component.html',
  styleUrls: ['./customize-ui-preview-modal.component.scss'],
  standalone: false,
})
export class CustomizeUiPreviewModalComponent implements CustomModal<PreviewModalViewProperties> {
  private activeModal = inject(NgbActiveModal);

  modalProperties: PreviewModalViewProperties;

  onCloseClick(): void {
    this.activeModal.close(false);
  }
}
